@if (impersonation.isActive()) {
    <gt-impersonation-bar />
}
@if (showLoadingIndicator()) {
    <div class="loading-indicator-container">
        <gt-loading-indicator />
    </div>
}
<router-outlet></router-outlet>
